// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectPayment_root__H0-ZQ","text":"SelectPayment_text__1dtPS","title":"SelectPayment_title__1lcoa","btn":"SelectPayment_btn__2umyV"};